module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page photosets */

(function(fox) {

	fox.registerWidget('SitePage_Photosets', {}, 'Site_Page');
	
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/photosets.js
// module id = 1279
// module chunks = 4